import React from "react";
import "./style/Loading.css";
const Loading = () => {
  return (
    <div className="container d-flex flex-centering">
      <div class="sk-chase ">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  );
};

export default Loading;
